module.exports = __webpack_public_path__ + "img/iptv.3c2614a8.png";